import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, Chip, Alert } from '@mui/material';
import api from '../../services/api';
import { useParams } from 'react-router-dom';

const AIResultDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [item, setItem] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!id) return;
      try {
        setLoading(true);
        setError(null);
        const res = await api.get(`/ai-analysis/${id}`);
        const data = res.data?.data || res.data;
        setItem(data);
      } catch (err: any) {
        setError(err.response?.data?.message || err.message || 'Failed to load details');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>AI Analysis Details</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>{error}</Alert>}
      {item && (
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box>
                <Typography variant="h6">{item.name}</Typography>
                <Typography variant="body2" color="text.secondary">Type: {item.analysisType}</Typography>
                <Typography variant="body2" color="text.secondary">Created: {new Date(item.createdAt).toLocaleString()}</Typography>
              </Box>
              <Chip label={item.status} color={item.status === 'completed' ? 'success' : item.status === 'failed' ? 'error' : 'default'} />
            </Box>
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle1">Results</Typography>
              <pre style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(item.results || {}, null, 2)}</pre>
            </Box>
          </CardContent>
        </Card>
      )}
      {!loading && !item && (
        <Typography variant="body2" color="text.secondary">No data found.</Typography>
      )}
    </Box>
  );
};

export default AIResultDetail;